import HttpStatus from 'ha/constants/HttpStatus';

import { ApiError } from './errors';

/**
 * matches JSON payload content type header:
 *   - `application/json`
 *   - `application/json; charset=utf-8`
 *   - `application/vnd.housinganywhere.moneta.v1 + json; charset=utf-8` (from moneta)
 */
const JSON_CONTENT_TYPE_RE =
  /^application\/(?:vnd\.housinganywhere\.moneta\.v1 \+ )?json(?:;.*)?$/;

export default function handleApiV2Response(response: Response) {
  const { ok, status, statusText, headers } = response;

  return Promise.resolve()
    .then(() => {
      if (status === HttpStatus.NO_CONTENT) {
        return undefined;
      }

      if (status === HttpStatus.ENTITY_TOO_LARGE) {
        throw new ApiError(status, statusText, {});
      }

      if (JSON_CONTENT_TYPE_RE.test(headers.get('content-type') || '')) {
        return response.json();
      }

      return undefined;
    })
    .then(data => {
      if (!ok) {
        throw new ApiError(status, statusText, data || {});
      }

      return { status, data };
    });
}
